import BlockTitle from "../blockTitle";
import {useCategorySelect} from "../../../../../../api/base";
import {useNavigate} from "react-router";
import {useTranslation,getI18n} from "react-i18next";
import {Swiper, SwiperSlide} from "swiper/react";
import {mediaMatch} from "../../../../../../utils";

export default function Category() {
  const lang = getI18n().language;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { result } = useCategorySelect({ businessType: 'orderProductType', sourceType: 'agent' });
  const isMdmax = mediaMatch.isMdmax;
  let categorys = [];
  
  if (result.data) {
    categorys = result.data.filter(item => item.showPicView);
  }
  
  const gotoGoodsList = (categoryId) => {
    let url = '/goodsList';
    if (categoryId) url += `?categoryId=${categoryId}`;
    navigate(url);
  };
  
  return (
    <div className="container-center mobile text-[0px] md:pb-[120px]">
      <BlockTitle title={t('商品分类')}
                  style={{ textAlign: 'left', paddingLeft: 0, marginBottom: 5 }}
                  labelClick={() => gotoGoodsList()}/>
      <div className="flex flex-wrap mdmax:flex-col">
        <Swiper slidesPerView={'auto'}
                spaceBetween={isMdmax ? 10 : 45}
                style={{ width: '100%', marginLeft: 5 }}
        >
          {
            categorys.map((item, i) => (
              <SwiperSlide
                className="cursor-pointer py-[15px] mdmax:px-[15px] rounded-full md:p-[40px] bg-white mdmax:mb-[8px] text-center relative overflow-hidden w-[15%] mdmax:w-[25%]"
                onClick={() => gotoGoodsList(item.categoryId)}
                key={i}>
                <p className="text-[#333] mdmax:text-[13px] text-[15px] relative z-10 line-clamp-1 pt-[5px]">
                  {lang === "en" ? item.categoryEnName : item.categoryName}
                </p>
                <img className="md:hidden relative"
                     src={item.showPicView}
                     style={{
                       margin: '0 auto 10px',
                       padding: '10px 0 10px',
                       zIndex: 10,
                       width: (document.body.offsetWidth * 0.94),
                     }}/>
                <img className="mdmax:hidden relative"
                     src={item.showPicView}
                     style={{
                       width: '100%',
                       padding: '20px 0 35px 0',
                       zIndex: 20
                     }}/>
                <p style={{
                  position: 'absolute',
                  backgroundColor: 'transparent',
                  border: '2px solid #E7EBF2',
                  top: '53%',
                  left: '50%',
                  transform: 'translate(-50%,-50%)',
                  width: '80%',
                  height: '80%',
                  borderRadius: 999
                }}/>
                <p style={{
                  position: 'absolute',
                  width: '100%',
                  backgroundColor: '#fff',
                  height: '75%',
                  top: 0,
                  left: 0,
                  // transform:'translateY(-50%)'
                }}/>
              </SwiperSlide>
            ))
          }
        </Swiper>
      </div>
    </div>
  );
}
